var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabIconForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 43.703 45.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    transform: "translate(-1.574 -1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22636",
    "data-name": "Path 22636",
    d: "M9.152,12.535a1.363,1.363,0,1,0,0,2.727H23.771a1.363,1.363,0,0,0,0-2.727Z",
    transform: "translate(3.2 5.888)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22637",
    "data-name": "Path 22637",
    d: "M15.726,17.644H9.152a1.363,1.363,0,1,0,0,2.727h6.573a1.363,1.363,0,0,0,0-2.727Z",
    transform: "translate(3.2 8.519)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22638",
    "data-name": "Path 22638",
    d: "M18.724,43.517H8.347A4.056,4.056,0,0,1,4.3,39.457V11.841a4.056,4.056,0,0,1,4.045-4.06h2.816v.342a3.61,3.61,0,0,0,3.607,3.605H27.8a3.61,3.61,0,0,0,3.607-3.605V7.781h2.8a4.008,4.008,0,0,1,4.043,4.06v7.771a1.363,1.363,0,1,0,2.727,0V11.841a6.787,6.787,0,0,0-6.772-6.787H31.4V4.705A3.61,3.61,0,0,0,27.8,1.1H14.769a3.61,3.61,0,0,0-3.607,3.605v.348H8.347a6.788,6.788,0,0,0-6.773,6.787V39.457a6.788,6.788,0,0,0,6.773,6.787H18.724a1.363,1.363,0,0,0,0-2.727ZM13.892,4.705a.879.879,0,0,1,.879-.879H27.8a.879.879,0,0,1,.879.879V8.122A.879.879,0,0,1,27.8,9H14.77a.879.879,0,0,1-.879-.879Z",
    transform: "translate(0 0)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22639",
    "data-name": "Path 22639",
    d: "M36.443,17.834a5.062,5.062,0,0,0-6.993,0L17.363,29.922a2.631,2.631,0,0,0-.736,1.427l-.664,3.922a2.641,2.641,0,0,0,3.042,3.04l3.921-.662a2.631,2.631,0,0,0,1.427-.736L36.44,24.826A4.95,4.95,0,0,0,36.443,17.834ZM22.473,34.962l-3.819.762.639-3.874,8.664-8.664,3.137,3.137ZM34.513,22.9l-1.494,1.5-3.136-3.136,1.5-1.5A2.216,2.216,0,1,1,34.513,22.9Z",
    transform: "translate(7.391 7.895)",
    fill: "#9797bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconForm);
export default __webpack_public_path__ + "static/media/TabIconForm.84923cda514571aba9d22d7f3589e033.svg";
export { ForwardRef as ReactComponent };